import React from 'react';

const HighlightImageTwo = () => {
  const highlightImages = [
    {
      id: 1,
      image: '/images/HighLightImageTwo/premium_bn_857203e5-3de2-41e5-a892-f408b309580c.webp',
      alt: 'Premium Banner'
    }
  ];

  return (
    <section className="py-6 sm:py-8 lg:py-12 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-4 sm:gap-6">
          {highlightImages.map((item) => (
            <div key={item.id} className="w-full rounded-lg overflow-hidden">
              <img
                src={item.image}
                alt={item.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-auto object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightImageTwo;

